<template>
  <component
    :is="currentView"
    :show="show"
    :class="type"
    :confirm-text="confirmText"
    @onConfirm="onConfirm"
    @onCancel="onCancel"
    @onShow="$emit('onShow')"
    @onHide="$emit('onHide')"
    >
  </component>
</template>

<script>
  import Alert from './alert'
  import Confirm from './confirm'
  import Prompt from './prompt'

  const maps = {
    alert: Alert,
    confirm: Confirm,
    prompt: Prompt
  }

  export default {
    props: {
      type: {
        type: String,
        default: 'alert'
      }
    },
    data () {
      return {
        show: false,
        confirmText: '确定'
      }
    },
    computed: {
      currentView () {
        return maps[this.type]
      }
    },
    methods: {
      onConfirm (e, d) {
        this.$emit('onConfirm', e, d)
      },
      onCancel (e, d) {
        this.$emit('onCancel', e, d)
      }
    }
  }
</script>

<style lang="stylus">
  @import '../../common/css/mixmin'

  .dialog-hd
    padding 0 px2rem(30px)
    text-align center
    white-space nowrap
    text-overflow ellipsis
    overflow hidden
    border-top-left-radius 5px
    border-top-right-radius 5px
    .dialog-title
      margin 0
      padding 0
      font-size px2rem(28px)
      line-height px2rem(80px)
  .dialog-bd
    padding px2rem(20px) px2rem(30px)
    font-size px2rem(28px)
    text-align center
    line-height 2
    .form-control
      display block
      padding 6px 15px
      width 100%
      line-height 1
      border 1px solid #60c9c8
      border-radius 5px
      box-sizing border-box
  .dialog-ft
    display table
    width 100%
    padding 0
    setTopLine(#ddd)
    .dialog-btn
      display table-cell
      font-size px2rem(28px)
      line-height px2rem(80px)
      text-align center
      border none
      &:first-child
        border-bottom-left-radius 5px
      &:last-child
        border-bottom-right-radius 5px
      &.default
        color #21507f
        background-color transparent
      &.primary
        color #fff
        background-color #60c9c8

  .alert .dialog-ft .dialog-btn
    width 100%
  .confirm .dialog-ft .dialog-btn
    width 50%
</style>



// WEBPACK FOOTER //
// dialog.vue?3743cb45